import * as React from 'react';
import { localize } from 'core/localization';
import { INPUT_TYPE } from 'constants/components';
import { FormTitle, LoginInput, LoginFormContainer, LoginInputWrapper } from './LoginForm.styled';

type LoginFormProps = {
  name: boolean;
  email: boolean;
  onChange(e?: any): void;
  onBlur(e?: any): void;
  getRefs(e?: any): void;
  theme?: { [key: string]: any }
};

export const LoginForm = (props: LoginFormProps) => {
  const { name, email, onChange, onBlur, getRefs } = props;
  return (
    <LoginFormContainer>
      <FormTitle>{localize('[please identify yourself]')}</FormTitle>
      <LoginInputWrapper validationStatusBeforeSubmit={name}>
        <LoginInput
          idInput="name"
          type={INPUT_TYPE.TEXT}
          refInput={(node: any) => getRefs(node)}
          name="name"
          labelText="Name"
          placeholder="John Doe"
          onChange={onChange}
          onBlur={onBlur}
          validIcon={false}
          pattern="^(?!\s*$).+"
          textError={localize('[error name input]')}
          validationStatusBeforeSubmit={name}
          theme={props.theme}
        />
      </LoginInputWrapper>
      <LoginInputWrapper validationStatusBeforeSubmit={email}>
        <LoginInput
          idInput="email"
          type={INPUT_TYPE.EMAIL}
          refInput={(node: any) => getRefs(node)}
          name="email"
          labelText="Email"
          placeholder="john@example.com"
          autoComplete="new-email"
          onChange={onChange}
          onBlur={onBlur}
          validIcon={false}
          textError={localize('[error email input]')}
          validationStatusBeforeSubmit={email}
          theme={props.theme}
        />
      </LoginInputWrapper>
    </LoginFormContainer>
  );
};

export default LoginForm;
